import Card from "../ui/card/Card";
import Icon from "../ui/Icon";

const CardComponent = ({ card }) => (
    <Card className="border-0 h-100 overflow-auto" style={{ minHeight: "250px", maxHeight: "350px" }}>
        <div className="d-flex flex-column gap-4">
            <div className="d-flex flex-column gap-4">
                <div className="d-flex align-items-start gap-2">
                    <div className={`card-icon p-2 bg-opacity-25 rounded-2 bg-${card.iconBgColor}`}>
                        <Icon name={card.icon} width={32} />
                    </div>
                    <div>
                        <h6 className="card-title fw-semibold lh-base mb-0">{card.title}</h6>
                        {card.subTitle &&
                            Object.entries(card.subTitle).map(([key, value]) => (
                                <p
                                    key={key}
                                    className={`card-subtitle m-0 fs-sm fs-xs fw-medium opacity-75 ${card.subTitleColor ?? ''}`}
                                >
                                    {key} : {value}
                                </p>
                            ))}
                    </div>
                </div>
                <div className="row row-gap-3">
                    {card.items.map((item, idx) => {
                        const [label, value] = Object.entries(item)[0];
                        return (
                            <div key={idx} className={card.column || 'col-md-6'}>
                                <h6 className="card-title text-secondary fs-md fw-semibold lh-base mb-0">{label}</h6>
                                <p className="m-0 fs-sm fs-xs fw-medium opacity-100">{value}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    </Card>
);

export default CardComponent;
